<template>
  <Layout>
    <div class="demo-page">
      <!-- Hero Section -->
      <section class="demo-hero">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-8 mx-auto text-center">
              <span class="badge-promo">Solution Café Hôtel Restaurant</span>
              <h1 class="demo-title mb-4 mt-3">
                Digitalisez votre établissement <br />
                <span class="text-gradient">en quelques clics</span>
              </h1>
              <p class="demo-subtitle mb-5">
                Découvrez comment DIGITABLE transforme l'expérience client et 
                optimise la gestion de votre Café, Hôtel ou Restaurant.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Video Presentation Section -->
      <section class="video-section">
        <div class="container">
          <div class="video-container">
            <div class="video-glow"></div>
            <div class="video-wrapper shadow-lg">
<iframe width="1455" height="773" src="https://www.youtube.com/embed/EJGsKulCcEM" title="Démo DIGITABLE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </section>

      <!-- Key Highlights Section (New) -->
      <section class="highlights-section py-5">
        <div class="container">
          <div class="row g-4">
            <div class="col-md-4" v-for="(feature, index) in features" :key="index">
              <div class="feature-card m-2">
                <div class="feature-icon">{{ feature.icon }}</div>
                <h4>{{ feature.title }}</h4>
                <p>{{ feature.desc }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";

export default {
  components: { Layout },
  data() {
    return {
      features: [
        { icon: '', title: 'Menu Digital', desc: 'Un menu interactif accessible via QR Code, sans contact et facile à mettre à jour.' },
        { icon: '', title: 'Commande Rapide', desc: 'Réduisez le temps d\'attente avec la prise de commande directe depuis la table.' },
        { icon: '', title: 'Suivi Instantané', desc: 'Gérez vos stocks et vos ventes en temps réel via un tableau de bord intuitif.' },
      ]
    };
  }
};
</script>

<style scoped>
/* Global Page Style */
.demo-page {
  background: #fcfdfe;
  color: #2d3436;
  overflow-x: hidden;
}

/* Hero Section */
.demo-hero {
  padding: 40px 0 30px;
  background: radial-gradient(circle at top right, #f0f4ff, #ffffff);
  text-align: center;
}

.badge-promo {
  background: rgba(15, 43, 102, 0.1);
  color: #0f2b66;
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.demo-title {
  font-size: 3.5rem;
  font-weight: 800;
  color: #0f2b66;
  line-height: 1.2;
}

.text-gradient {
  background: linear-gradient(135deg, #1b4ba1, #ffc107);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.demo-subtitle {
  font-size: 1.25rem;
  color: #636e72;
  max-width: 650px;
  margin: 0 auto;
}

/* Video Section */
.video-section {
  position: relative;
  padding-bottom: 80px;
}

.video-container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
}

.video-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 80%;
  background: rgba(27, 75, 161, 0.2);
  filter: blur(80px);
  z-index: -1;
  border-radius: 50%;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  border-radius: 24px;
  overflow: hidden;
  border: 8px solid white;
  background: #000;
  transition: transform 0.3s ease;
}

.video-wrapper:hover {
  transform: translateY(-10px);
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Features Section */
.feature-card {
  background: white;
  padding: 40px 30px;
  border-radius: 20px;
  text-align: center;
  height: 100%;
  border: 1px solid #edf2f7;
  transition: all 0.3s ease;
}

.feature-card:hover {
  box-shadow: 0 20px 40px rgba(0,0,0,0.05);
  border-color: #1b4ba1;
}

.feature-icon {
  font-size: 2.5rem;
  margin-bottom: 20px;
}

.feature-card h4 {
  color: #0f2b66;
  font-weight: 700;
  margin-bottom: 15px;
}

.feature-card p {
  color: #636e72;
  font-size: 1rem;
  line-height: 1.6;
}

/* CTA Section */
.cta-section {
  padding: 80px 0;
}

.cta-card {
  background: linear-gradient(135deg, #0f2b66, #1b4ba1);
  color: white;
  padding: 60px 40px;
  border-radius: 30px;
  box-shadow: 0 20px 50px rgba(15, 43, 102, 0.3);
}

.cta-btn {
  padding: 15px 40px !important;
  font-weight: 700 !important;
  border-radius: 12px !important;
  font-size: 1.1rem !important;
  transition: all 0.3s ease !important;
}

.cta-btn:hover {
  box-shadow: 0 10px 20px rgba(255, 193, 7, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .demo-title {
    font-size: 2.2rem;
  }
  .demo-hero {
    padding: 60px 0 40px;
  }
  .cta-card {
    padding: 40px 20px;
  }
}
</style>